module.exports = __webpack_public_path__ + "img/fan_inspection_banner.57d72ab7.png";